import { render, staticRenderFns } from "./PlatformExportfileConfig.vue?vue&type=template&id=1be57637&"
import script from "./PlatformExportfileConfig.vue?vue&type=script&lang=js&"
export * from "./PlatformExportfileConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports